export default {
	'expected-quantity': 'Cantidad esperada',
	'inventory-qty': 'Cantidad en inventario',
	'reserved-quantity': 'Cantidad reservada',
	'available-to-sell': 'Capaz de vender',
	'sales-availability': 'Disponibilidad de ventas',
	'weighted-average-percentage': 'Promedio Ponderado.',
	display: 'Pantalla'
}